import React from "react";

const Services = () => {
  // services details
  const services = [
    {
      name: "ERP Integration",
      desc: "Epicor 9, 10 and Kinetic, on-prem and SaaS. BPMs, BAQs, Kinetic Functions, Application Studio, customization layers, and business-object tracing down to the underlying C# API methods.",
      icon: "fas fa-project-diagram",
    },
    {
      name: "Software Development",
      desc: "Clean, reusable code built to outlive the project it was written for. C#, .NET, Node.js, REST service design and consumption, OAuth 2.0 / JWT, Java, MSSQL.",
      icon: "fas fa-code",
    },
    {
      name: "Web Development",
      desc: "Pixel-accurate implementation of a provided design, built to hold up. React, Angular, JavaScript, PHP, HTML5, CSS3, SASS, ASP.NET MVC, Drupal.",
      icon: "fas fa-desktop",
    },
    {
      name: "Databases & Data",
      desc: "MSSQL, MySQL, Postgres, Progress, MongoDB. Stored procedures, functions, query plan analysis and optimization, Entity Framework, LINQ. Large-dataset analysis and reporting.",
      icon: "fas fa-database",
    },
    {
      name: "Devices & Applications",
      desc: "Responsive, stateless applications: RFID and barcode capture, shipping and receiving with image attachment and on-the-fly label printing, pallet optimization across variable sizes and weights.",
      icon: "fas fa-barcode",
    },
    {
      name: "Automation",
      desc: "Epicor scheduled processes and System Agent configuration, automated functions and BAQ processes, Windows services and task scheduling, Docker containers for development and integration environments.",
      icon: "fas fa-clock",
    },
  ];

  return (
    <section id="services" className="section bg-light">
      <div className="container">
        {/* Heading */}
        <p className=" text-center mb-2 wow fadeInUp">
          <span className="bg-primary text-dark px-2">What I Do</span>
        </p>
        <h2 className="text-10 fw-600 text-center mb-5 wow fadeInUp">
          How I can help your next project
        </h2>
        {/* Heading end*/}
        <div className="row gy-5 mt-5">
          {services.length > 0 &&
            services.map((service, index) => (
              <div className="col-sm-6 col-lg-4 wow fadeInUp" key={index}>
                <div className="featured-box text-center px-md-4">
                  <div className="featured-box-icon text-primary text-13">
                    {" "}
                    <i className={service.icon} />
                  </div>
                  <h3 className="text-6 fw-600 mb-3">{service.name}</h3>
                  <p className="text-muted mb-0">{service.desc} </p>
                </div>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
